<svg class="graph">
    <g class="inner"></g>
</svg>
